import { render } from "./TestResultGridSampleColumn.vue?vue&type=template&id=fdae89a2&scoped=true&ts=true"
import script from "./TestResultGridSampleColumn.vue?vue&type=script&lang=ts"
export * from "./TestResultGridSampleColumn.vue?vue&type=script&lang=ts"

import "./TestResultGridSampleColumn.vue?vue&type=style&index=0&id=fdae89a2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdae89a2"]])

export default __exports__